import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import { AttachmentModel } from '@models/types'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useAttachment from '@hooks/useAttachment'

// @ts-expect-error TS7006
const confirmDelete = (deleteAttachment, deleteFn) => {
  const deleteAttachmentPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Attachment Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete File?',
    }).then(({ value }) => {
      if (value){
        deleteAttachment(deleteAttachmentPayload)
      }
    })
}

interface AttachmentListItemProps {
  attachment: AttachmentModel,
  boxProps?: object,
  callbacks?: {
    deleteAttachment: (payload: HandleCallbackActionParams) => void,
  },
}

const AttachmentListItem = (props: AttachmentListItemProps) => {
  const { attachment, boxProps, callbacks } = props
  const { deleteAttachment } = callbacks || {}

  const {
    // @ts-expect-error TS2339
    dates: {
      created: {
        date,
      },
    },
    file_file_name,
  } = attachment

  const {
    callbacks: {
      deleteAttachment: deleteFn,
      downloadAttachment,
    },
  } = useAttachment(attachment)

  return (
    <DashboardModuleListItem boxProps={boxProps} isSidebar secondaryText={`Uploaded ${date}`} title={file_file_name}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS7006 */}
        <Link greyLink onClick={e => downloadAttachment(e)} textProps={{ marginRight: 'medium' }}>
          <FontAwesomeIcon icon={faFileDownload} />
        </Link>

        {deleteAttachment && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteAttachment, deleteFn)} type="delete" />
        )}
      {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AttachmentListItem
